import { render } from "./Camarero.vue?vue&type=template&id=782c7a82&scoped=true"
import script from "./Camarero.vue?vue&type=script&lang=js"
export * from "./Camarero.vue?vue&type=script&lang=js"

import "./Camarero.vue?vue&type=style&index=0&id=782c7a82&lang=scss&scoped=true"

import exportComponent from "/var/www/clients/client1/web6/web/cartamovil-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-782c7a82"]])

export default __exports__